import odata from 'odata-client';
import {
    GET_ORGANISATION_DATA_REQUEST,
    GET_ORGANISATION_DATA_ERROR,
    GET_ORGANISATION_DATA_SUCCESS,
    TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';
/*import getToken from '../user/getToken';*/

export const tokenExpired = () => ({
    type: TOKEN_EXPIRED
});

export const getOrganisationDataRequest = () => ({
    type: GET_ORGANISATION_DATA_REQUEST,
});

export const getOrganisationDataError = errorOrResults => ({
    type: GET_ORGANISATION_DATA_ERROR,
    error: errorOrResults.message,
});

export const getOrganisationDataSuccess = payload => ({
    type: GET_ORGANISATION_DATA_SUCCESS,
    payload,
});

export default () => async (dispatch, getState) => {
    /*const authorizationHeader = getToken();*/
    dispatch(getOrganisationDataRequest())

    const query = odata({ service: getServiceUrl() }).resource(RESOURCES.OrganisationData);
    query.expand("Organisation($select=ID, ShortName, Name, Left, Right, IsBaseOrganisation)");
    query.orderby("Organisation/Left");
    const errorOrResult = await query.get({
        headers: {
            Authorization: `Bearer ${getState().user.token}`,
            ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const errorKey = "GENERAL_SERVER_ERROR";
                return new Error(errorKey);
            } else if (!ok) {
                console.log('get organisation data api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
                return new Error(errorKey);
            } else {
                const body = JSON.parse(res.body);
                const payload = body.value;
                const storeState = getState()
                if (storeState.organisationData.dataIsObject) {
                    const organisationDataById = {}
                    payload.forEach(obj => {
                        organisationDataById[obj.ID] = obj
                    })
                    return organisationDataById;
                }

                return payload
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(getOrganisationDataError(errorOrResult, GET_ORGANISATION_DATA_ERROR));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        dispatch(showNotification(errorOrResult.message, "error"))
        return;
    }

    dispatch(getOrganisationDataSuccess(errorOrResult));
};